import axios from 'axios';

import { Baseplan, NonPlannedHour, PlannedHour } from 'components/types';

import { Units } from 'components/enums';

import {
  ROSTER_BASEPLAN,
  SCENARIO_NON_PLANNED_HOURS,
  SCENARIO_NON_PLANNED_HOURS_GET,
  SCENARIO_PLANNED_HOURS,
  SCENARIO_PLANNED_HOURS_GET
} from 'RestAPIs/endpoints';

type GetBaseplansOptions = {
  scenarioId: number;
  costCenters: string;
  startDate: string;
  endDate: string;
  archived?: boolean;
  includeArchived?: boolean;
};

export const getBaseplans = ({
  scenarioId,
  costCenters,
  startDate,
  endDate,
  archived = false,
  includeArchived = false
}: GetBaseplansOptions) =>
  axios.get<Baseplan[]>(ROSTER_BASEPLAN, {
    params: {
      strictCostCenters: true,
      costCenters,
      startDate,
      endDate,
      archived,
      includeArchived
    },
    pathParams: { scenarioId }
  });

type GetPlannedHoursOptions = {
  scenarioId: number;
  year: number;
};

export const getPlannedHours = ({ scenarioId, year }: GetPlannedHoursOptions) =>
  axios.get<PlannedHour[]>(SCENARIO_PLANNED_HOURS_GET, {
    params: { year },
    pathParams: { scenarioId }
  });

export type PlannedHoursPayload = Omit<PlannedHour, 'scenarioId'>[];

export type SavePlannedHoursOptions = {
  scenarioId: number;
  year: number;
  payload: PlannedHoursPayload;
};

export const savePlannedHours = ({
  scenarioId,
  year,
  payload
}: SavePlannedHoursOptions) =>
  axios.post<PlannedHoursPayload>(SCENARIO_PLANNED_HOURS, payload, {
    params: { year },
    pathParams: { scenarioId }
  });

export const getNonPlannedHours = ({
  scenarioId,
  year
}: GetPlannedHoursOptions) =>
  axios.get<NonPlannedHour[]>(SCENARIO_NON_PLANNED_HOURS_GET, {
    params: { year },
    pathParams: { scenarioId }
  });

export type NonPlannedHourPayload = {
  costCenter: NonPlannedHour['costCenter'];
  dutyTypeId: number;
  function: NonPlannedHour['function'];
  functionId: string;
  quantity: number;
  description: string;
  hoursPerUnit: number;
  unit: keyof typeof Units;
  timeframe: { from: string; to: string };
};

type SaveNonPlannedHoursOptions = {
  scenarioId: number;
  year: number;
  payload: NonPlannedHourPayload;
};

export const saveNonPlannedHours = ({
  scenarioId,
  year,
  payload
}: SaveNonPlannedHoursOptions) =>
  axios.post<NonPlannedHourPayload>(SCENARIO_NON_PLANNED_HOURS, payload, {
    params: { year },
    pathParams: { scenarioId }
  });

type UpdateNonPlannedHourOptions = {
  scenarioId: number;
  id: number;
  payload: NonPlannedHourPayload;
};

export const updateNonPlannedHour = ({
  scenarioId,
  id,
  payload
}: UpdateNonPlannedHourOptions) =>
  axios.put<NonPlannedHourPayload>(
    `${SCENARIO_NON_PLANNED_HOURS}/${id}`,
    payload,
    {
      pathParams: { scenarioId }
    }
  );

type DeleteNonPlannedHoursSelectionOptions = {
  scenarioId: number;
  idsList: number[];
};

export const deleteNonPlannedHoursSelection = ({
  scenarioId,
  idsList
}: DeleteNonPlannedHoursSelectionOptions) =>
  axios.delete(`${SCENARIO_NON_PLANNED_HOURS}`, {
    params: {
      scenarioNonPlannedHoursIdsList: idsList.join(',')
    },
    pathParams: { scenarioId }
  });
